import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../services/configuration.service';
import { FeatureFlags } from '../services/configuration.service.model';

@Component({
  selector: 'release-notes-dialog',
  templateUrl: 'release-notes-dialog.component.html',
  styleUrls: ['release-notes-dialog.component.scss'],
  standalone: false,
})
export class ReleaseNotesDialogComponent implements OnInit {
  featureFlags$: Observable<FeatureFlags | null>;

  constructor(
    public dialogRef: MatDialogRef<ReleaseNotesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private configService: ConfigurationService,
  ) {
    this.featureFlags$ = this.configService.featureFlags$;
  }

  ngOnInit(): void { }

  onClickClose(): void {
    this.dialogRef.close();
  }
}
